module.exports = __webpack_public_path__ + "static/media/big-check-icon.474d8c54.svg";